import React from 'react';
import { Cpu, HardDrive, Network } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SEO } from '../components/SEO';
const layers = [{
  icon: Network,
  color: 'ai-teal',
  key: 'edge',
  num: '01'
}, {
  icon: Cpu,
  color: 'muted-gold',
  key: 'neuro',
  num: '02'
}, {
  icon: HardDrive,
  color: 'neural-green',
  key: 'hardware',
  num: '03'
}];
export function TechnologyApproach() {
  const {
    t,
    language
  } = useLanguage();
  const seoTitles = {
    en: 'Technology Stack - Edge Computing, Neuro-Symbolic AI | NEW ASIA TECH',
    id: 'Tumpukan Teknologi - Komputasi Edge, AI Neuro-Simbolik | NEW ASIA TECH'
  };
  const seoDescriptions = {
    en: 'NEW ASIA TECH technology architecture: Edge Computing Fabric, Neuro-Symbolic AI, Hardware-Software Fusion. Built on resilience, sovereignty, and explainability principles.',
    id: 'Arsitektur teknologi NEW ASIA TECH: Fabric Komputasi Edge, AI Neuro-Simbolik, Fusi Hardware-Software. Dibangun di atas prinsip ketahanan, kedaulatan, dan kemampuan dijelaskan.'
  };
  const seoKeywords = {
    en: 'edge computing, neuro-symbolic AI, explainable AI, hardware-software integration, distributed computing, AI architecture, technology stack, NEW ASIA TECH technology',
    id: 'komputasi edge, AI neuro-simbolik, AI yang dapat dijelaskan, integrasi hardware-software, komputasi terdistribusi, arsitektur AI, tumpukan teknologi, teknologi NEW ASIA TECH'
  };
  return <>
      <SEO title={seoTitles[language]} description={seoDescriptions[language]} keywords={seoKeywords[language]} url="/technology" type="article" data-id="element-478" />

      <div className="min-h-screen pt-32 pb-20 px-6" data-id="element-479">
        <div className="max-w-[1800px] mx-auto" data-id="element-480">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-481">
            <div className="lg:col-span-5" data-id="element-482">
              <div className="sticky top-32 animate-fade-in-up" data-id="element-483">
                <h1 className="text-5xl md:text-7xl font-display font-bold text-ivory mb-8" data-id="element-484">
                  {t('tech.title')}
                </h1>
                <p className="text-gray-400 text-lg mb-12" data-id="element-485">
                  {t('tech.subtitle')}
                </p>

                <div className="border border-white/10 bg-white/5 p-6 rounded-lg backdrop-blur-sm" data-id="element-486">
                  <div className="space-y-2" data-id="element-487">
                    <div className="h-12 bg-neural-green/20 border border-neural-green/50 rounded flex items-center justify-center text-xs font-mono text-neural-green" data-id="element-488">
                      APPLICATION LAYER
                    </div>
                    <div className="h-12 bg-ai-teal/20 border border-ai-teal/50 rounded flex items-center justify-center text-xs font-mono text-ai-teal" data-id="element-489">
                      INTELLIGENCE LAYER
                    </div>
                    <div className="h-12 bg-muted-gold/20 border border-muted-gold/50 rounded flex items-center justify-center text-xs font-mono text-muted-gold" data-id="element-490">
                      DATA LAYER
                    </div>
                    <div className="h-12 bg-white/10 border border-white/30 rounded flex items-center justify-center text-xs font-mono text-white" data-id="element-491">
                      PHYSICAL LAYER
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7 space-y-24" data-id="element-492">
              {layers.map((layer, idx) => {
              const Icon = layer.icon;
              return <section key={idx} className={`group animate-fade-in-up delay-${(idx + 1) * 100}`} data-id="element-493">
                    <div className="flex items-center mb-6" data-id="element-494">
                      <div className={`p-3 bg-white/5 border border-white/10 rounded mr-4 group-hover:border-${layer.color} transition-colors`} data-id="element-495">
                        <Icon className={`w-6 h-6 text-${layer.color}`} data-id="element-496" />
                      </div>
                      <div data-id="element-497">
                        <div className={`text-xs font-mono text-${layer.color} mb-1`} data-id="element-498">
                          {t(`tech.layer${idx + 1}`)}
                        </div>
                        <h2 className="text-3xl font-display font-bold text-ivory" data-id="element-499">
                          {t(`tech.${layer.key}`)}
                        </h2>
                      </div>
                    </div>
                    <p className={`text-gray-400 text-lg leading-relaxed mb-6 pl-16 border-l-2 border-white/10 group-hover:border-${layer.color} transition-colors duration-500`} data-id="element-500">
                      {t(`tech.${layer.key}.desc`)}
                    </p>
                    {idx === 0 && <div className="ml-16 h-40 bg-carbon border border-white/10 relative overflow-hidden group-hover:shadow-[0_0_20px_rgba(62,240,209,0.1)] transition-shadow" data-id="element-501">
                        <div className="absolute inset-0 flex items-center justify-around" data-id="element-502">
                          <div className="w-2 h-2 bg-ai-teal rounded-full animate-pulse" data-id="element-503" />
                          <div className="w-full h-px bg-white/10" data-id="element-504" />
                          <div className="w-4 h-4 bg-white/20 rounded-full border border-ai-teal" data-id="element-505" />
                          <div className="w-full h-px bg-white/10" data-id="element-506" />
                          <div className="w-2 h-2 bg-ai-teal rounded-full animate-pulse delay-75" data-id="element-507" />
                        </div>
                      </div>}
                  </section>;
            })}
            </div>
          </div>
        </div>
      </div>
    </>;
}